import React from "react";
import { OnboardingSlide } from "core/models/OnboardingSlide";
import Onboarding from "ui/components/molecules/Onboarding";
import useOnboarding from "ui/hooks/useOnboarding";

const onboardingSlides: OnboardingSlide[] = [
    {
        id: 1,
        image: "/static/img/onboarding-create-clips.png",
        title: "Editing and Exporting",
        body: (
            <p>
                Now that you&#39;ve got your first video, you can edit or export
                these immediately from here. Choose the download or share icons
                with the video of choice, for exporting to your pc, facebook,
                twitter or youtube. Or use the &#39;Edit&#39; functionality to
                trim, crop or resize your video, as well as add an intro, outro
                and/or overlay.
            </p>
        ),
        contactUs: false,
        buttonText: "Okay",
    },
];

const ClipsOnboarding: React.FC = () => {
    const { completed, onCompleted } = useOnboarding("clipsOnboarding");
    if (completed || completed === undefined) {
        return null;
    }
    return <Onboarding slides={onboardingSlides} onComplete={onCompleted} />;
};
export default React.memo(ClipsOnboarding);
